<template>
  <div class="border border-gray-300 rounded-lg">
    <div class="flex flex-col m-4">
      <div class="h-12 flex flex-row justify-between">
        <div>
          <img
            src="../../../assets/images/logos/zapier.png"
            class="h-9 w-9"
            style="max-width: none"
          />
        </div>
        <a
          class="btn-secondary h-10"
          :href="this.isDisabled ? '#' : 'https://zapier.com/developer/public-invite/156735/588bdc88dd392cd433f2975836ee9cd8/'"
          :target="this.isDisabled ? '' : '_blank'"
        >
          {{ $t('Connect') }}
        </a>
      </div>
      <div class="mt-4">
        <h4 class="font-bold text-neutral-900 text-base">{{ $t('Zapier') }}</h4>
        <p class="text-sm mt-1 text-neutral-600">
          {{ $t('Build custom automations and integrations with other apps') }}
        </p>
      </div>
      <p class="text-xs font-medium mt-2 text-neutral-700">
        {{ $t('Your API key:') }}
        <span class="font-normal font-mono text-neutral-900 text-sm">{{
          zApiKey
        }}</span>
      </p>
    </div>

  </div>
</template>

<script>
export default {
  props: ["zApiKey", "isDisabled"],
};
</script>
